/*
 * "Alertas": lista de tiendas con IGI actual mayor que 0 y menor que 4.0 (calculado en el servidor,
 * igi/services/scoring.is_alert), en orden ascendente (las mas criticas primero). Solo para quien ve
 * todo el territorio (igi_view_all). Reutiliza GET /igi/resumen/ (campo "alertas"), sin endpoint propio.
 */
import React, {useCallback, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Breadcrumbs from "../../../../components/breadcrumbs";
import {clear_igi, get_igi_resumen, GET_IGI_RESUMEN_SUCCESS} from "../../../../redux/igi";
import {NivelBadge, formatoNota} from "../niveles";

const Alertas = () => {
    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const resumen = useSelector((state) => state.igi_module._get_resumen);
    const [pedido, setPedido] = useState(false);

    const recargar = useCallback(() => {
        setPedido(true);
        dispatch(get_igi_resumen(token));
    }, [dispatch, token]);

    useEffect(() => {
        dispatch(clear_igi(GET_IGI_RESUMEN_SUCCESS));
        recargar();
    }, [dispatch, recargar]);

    const cargando = pedido && resumen.status === 0;
    const error = resumen.status !== 0 && resumen.status !== 200
        ? (resumen.message || "No se pudieron cargar las alertas") : null;
    const alertas = resumen.data && resumen.data.alertas ? resumen.data.alertas : [];

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs title="Alertas" items={[]}/>
                    </div>
                </div>
                <div className="content-body">
                    {cargando && (
                        <div className="alert alert-info" role="status" aria-busy="true">
                            <i className="bx bx-loader-alt bx-spin mr-50"/> Cargando alertas…
                        </div>
                    )}
                    {error && <div className="alert alert-danger">{error}</div>}
                    {!cargando && !error && alertas.length === 0 && (
                        <div className="alert alert-success">
                            <i className="bx bx-check-circle mr-50"/> Sin tiendas en alerta.
                        </div>
                    )}
                    {alertas.map((a) => (
                        <Link key={a.tienda} to={`/igi/tiendas/${a.tienda}`} className="text-body">
                            <div className="card mb-1">
                                <div className="card-body p-1 d-flex justify-content-between align-items-center">
                                    <div>
                                        <strong>{a.codigo}</strong> <span className="text-muted">{a.nombre}</span>
                                        <div className="small text-muted">{a.zona}</div>
                                    </div>
                                    <div className="text-right">
                                        <div style={{fontSize: "1.3rem", fontWeight: 700}}>{formatoNota(a.igi)}</div>
                                        <NivelBadge nivel={a.nivel}/>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Alertas;
